import { PLUGIN_THUMBNAILS } from "../../core/index.js";
import { Thumbnails } from "./Thumbnails.js";
export default Thumbnails;
